import { createUniqueClassName } from '@leafygreen-ui/lib';

export const ButtonClassName = createUniqueClassName('button');
